module.exports = __webpack_public_path__ + "static/quickstart-3-f47dc1f63eda901e682df2075a0fc9c3.png";